import React, { Component } from 'react';
import { View, Text } from 'react-native';
import { SIcon, SImage, SNavigation, SPage, SStorage, STheme, SThread, SView } from 'servisofts-component2';
import SSocket from 'servisofts-socket';
import MDL from '../MDL';
import Close from '../Assets/svg/close.svg';

export default class Popupsinicio extends Component {
    static _INSTANCE: Popupsinicio = null;
    static open() {
        if (this._INSTANCE) {
            this._INSTANCE.open();

        }
    }
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            index: 0,
            data: {}
        };
        Popupsinicio._INSTANCE = this;
    }

    componentDidMount() {
        const usr = MDL.usuario.session
        SSocket.sendPromise({
            component: "popup_inicio",
            type: "get_popups",
            key_usuario: MDL.usuario?.session?.key,
        }).then(e => {
            if (!e.data) return;
            let arr = e.data.sort((a, b) => a.index - b.index);
            if (!usr || (usr?.genero && usr?.fecha_nacimiento)) {
                arr = arr.filter(a => a.key != "popup_cumple")
            }

            if (!usr) {
                arr = arr.filter(a => a.key != "popup_tag")
            }

            SSocket.sendPromise({
                component: "insignia_usuario",
                type: "getCantidad",
                key_usuario: MDL.usuario?.session?.key,
            }).then(e => {
                if (!usr || ((usr?.CI && usr?.CI_EXPE) && e.data > 0)) {
                    arr = arr.filter(a => a.key != "popup_ci")
                }
                this.setState({ data: arr })
            }).catch(e => {
                this.setState({ data: arr })
            })

            this.setState({ data: arr })
        })
    }

    handlePress(tipo, popup) {
        SSocket.sendPromise({
            component: "popup_inicio",
            type: "marcar",
            data: {
                key_usuario: MDL.usuario?.session?.key,
                key_popup_inicio: this?.popup?.key,
                tipo: tipo
            }

        }).then(e => {
            if (popup?.url && tipo == "manual") {
                console.log(e);
                SStorage.setItem("popup_inicio_click", JSON.stringify(e.data));
            }
        })

        this.state.index += 1;

        if (popup?.url && tipo == "manual") {
            SNavigation.navigate(popup.url, popup.params)

            this.state.index = this.state.data.length;
            this.setState({ visible: false })
            return;
        }

        this.setState({ ...this.state })
    }

    open() {
        if (this.state.visible) return;
        if (this.state.data[this.state.index]) {
            console.log("Entro al open 2    ")
            this.setState({ visible: true })
        }
    }

    popupCierre() {
        return <SView style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            backgroundColor: "#000000BB",
            justifyContent: 'center',
            alignItems: 'center',
            padding: 16
        }}>
            {/* <SImage src={require("../Assets/img/popup_no_disponible.png")} /> */}
        </SView>
    }

    render() {
        //return this.popupCierre() // TODO Si vuelve el proyecto Quitar. 

        if (!this.state.visible) return null;
        this.popup = this.state.data[this.state.index];
        if (!this.popup) return null;
        if (this.popup.tiempo) {
            new SThread(this.popup.tiempo, "pasar_al_siguiente", true).start(a => {
                this.handlePress("automatico", this.popup);
            })
        }

        console.log("this.popup", this.popup);
        return <SView style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            backgroundColor: "#000000BB",
            justifyContent: 'center',
            alignItems: 'center',
            padding: 16
        }} onPress={this.handlePress.bind(this, "manual", this.popup)}>
            <SImage src={SSocket.api.root + "popup_inicio/" + this.popup?.key} />
            {this.renderClose()}
        </SView>
    }

    renderClose() {
        return <SView style={{
            width: 50,
            height: 50,
            position: "absolute",
            top: 8,
            right: 8,
        }} onPress={() => {
            this.handlePress("close", this.popup);
        }}>
            <Close name='Close' width={40} height={40}  fill={STheme.color.secondary} />
        </SView>
    }
}
